import 'intersection-observer';

export function boot() {
  const topnav = document.querySelector('#top-dropdown2 .tab-group');
  const topDropdown = document.getElementById('top-dropdown2');
  const selfcare = document.querySelector('.self-care-bg');
  const menuLinks = document.querySelectorAll('a.tab-nav');
  const menuLength = menuLinks.length;
  const navTitle = document.querySelector('.nav-question');
  const icon = document.querySelector('.clicky i');
  // console.log(menuLength)

  function scrollDown(div) {
    $('html,body').animate({
      scrollTop: $(div).offset().top,
    });
  }

  var stickyNavTop = topDropdown.offsetTop;
  // console.log(stickyNavTop)
  var oldValue;

  var stickyNav = function () {
    var scrollTop = $(window).scrollTop();
    //we want it to always have a sticky if it's scrolled past the first section
    if (scrollTop > selfcare.offsetTop) {
      topDropdown.classList.add('sticky');
    } else {
      topDropdown.classList.remove('sticky');
    }
    var windowTop = Math.max($('body').scrollTop(), $('html').scrollTop());
  };

  function colorSections(value) {
    if (value == 'self-care') {
      topDropdown.style.borderBottom = '2px solid #e283aa';
    }
    if (value == 'entertainment') {
      topDropdown.style.borderBottom = '2px solid #f15a24';
    }
    if (value == 'learning') {
      topDropdown.style.borderBottom = '2px solid #0db75d';
    }
    if (value == 'be-helpful') {
      topDropdown.style.borderBottom = '2px solid #efcc03';
    }
    if (value == 'community') {
      topDropdown.style.borderBottom = '2px solid #2645ef';
    }
    if (value == 'internetland') {
      topDropdown.style.borderBottom = '2px solid #986FB1';
    }
    if (value == 'covid-19') {
      topDropdown.style.borderBottom = '2px solid #333333';
    }
    if (value == 'for-parents') {
      topDropdown.style.borderBottom = '2px solid #725948';
    }
  }

  stickyNav();
  $(window).scroll(function () {
    stickyNav();
  });

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  };

  const sections = document.querySelectorAll('.topic');
  let sectionId;
  let oldId;
  let isLeaving = false;

  let sectionObserver = new IntersectionObserver((entries, options) => {
    entries.forEach((entry) => {
      oldId = sectionId;
      if (entry.isIntersecting) {
        // console.log("hello!" + entry);
        sectionId = entry.target.id;
        //topnav.querySelector('.tab-nav').classList.add('flex-active');
        //topnav.querySelector('a.tab-nav').classList.add('flex-active');
        //console.log("is this fucking adding flex acive")
        topnav.querySelector('.' + sectionId + '-nav').classList.add('active');
        topnav
          .querySelector('.' + sectionId + '-nav')
          .parentElement.classList.add('flex-active');
        //console.log('section id is now', sectionId);
        colorSections(sectionId);
      }

      if (oldId != sectionId && oldId != undefined) {
        // console.log('does it still know oldId?' + oldId);
        topnav
          .querySelector('.' + oldId + '-nav')
          .parentElement.classList.remove('flex-active');
        //console.log("stop taking flex active away")
        topnav.querySelector('.' + oldId + '-nav').classList.remove('active');
      }
    });
  });

  sections.forEach((section) => {
    sectionObserver.observe(section, options);
  });

  function clickEvent(event) {
    event.preventDefault();
    // console.log($(this))
    var selectedSection = this.hash;
    // console.log(selectedSection);
    selectedSection = selectedSection.substring(1);

    if (selectedSection != sectionId) {
      scrollDown($("a[name='" + selectedSection + "']"));
    }
  }

  let docHeight = window.innerHeight;
  // console.log(docHeight)
  let open = false;
  function menuClick(event) {
    // console.log("the title was clicked")

    //if menu is closed, open it
    if (!open) {
      //make menu take up full screen
      topDropdown
        .querySelector('.nav-container')
        .setAttribute('id', 'full-height');

      //set to documentElement.clientHeight if we need to in js
      if (tinySize) {
        // document.querySelector('#full-height').style.height = docHeight + "px";
        //console.log(docHeight)
      }

      //add id to make it show
      topnav.setAttribute('id', 'show-menu');

      //switch out icons
      icon.classList.remove('LATMenu');
      icon.classList.add('LATClose01');

      //switch variable so we know menu is open
      open = true;
    }
    //if the menu is open, close it
    else if (open) {
      //undo full screen
      topDropdown.querySelector('.nav-container').removeAttribute('id');

      //set the js back to auto
      // if (tinySize) {
      //     topDropdown.querySelector('.nav-container').style.height = "auto";
      // }

      //remove id that let menu open
      topnav.removeAttribute('id');

      //switch out icons
      icon.classList.remove('LATClose01');
      icon.classList.add('LATMenu');

      //and now it's no longer open
      open = false;
    }
  }

  // function mobileEvents() {
  //   clickEvent();
  //   menuClick();
  // }

  // function eventHandler(e) {
  //   console.log("event handler?")
  //   e = e || window.event;
  //   var target = e.target || e.srcElement;
  //   clickEvent(e);
  //   menuClick();
  // }

  function mediaQuery(x) {
    //if we're at max-width of 768
    if (x.matches) {
      // console.log("TABLET.. ish SIZE")
      navTitle.addEventListener('click', menuClick);
      for (var i = 0; i < menuLinks.length; i++) {
        menuLinks[i].addEventListener('click', menuClick);
      }
    } else {
      //create a scrolly effect on page view; only want in desk top
      for (var i = 0; i < menuLinks.length; i++) {
        menuLinks[i].addEventListener('click', menuClick);
      }
    }
  }

  let tinySize;
  function tinyMediaQuery(x) {
    //if we're at max-width of 500
    if (x.matches) {
      tinySize = true;
    } else {
      tinySize = false;
    }
  }

  var mq = window.matchMedia('(max-width: 1068px)');
  mediaQuery(mq);
  mq.addListener(mediaQuery);

  var mq2 = window.matchMedia('(max-width: 500px)');
  tinyMediaQuery(mq2);
  mq2.addListener(tinyMediaQuery);
}
